import enviro from 'enviro';
import { EndpointKey } from '../../http/EndpointKey';
import { HttpStatus } from '../../store/http-responses/types';
const GOOGLE_CONTACTS_APP_ID_QA = 1203680;
const GOOGLE_CONTACTS_APP_ID_PROD = 232794;
export const getGoogleContactsAppId = () => {
  return enviro.isProd() ? GOOGLE_CONTACTS_APP_ID_PROD : GOOGLE_CONTACTS_APP_ID_QA;
};
export const GOOGLE_DATA_SYNC_POPUP_CLOSED = 'OAuthWindowClosed';
export let GoogleSyncErrorStatus;

(function (GoogleSyncErrorStatus) {
  GoogleSyncErrorStatus["Loading"] = "loading";
  GoogleSyncErrorStatus["Completed"] = "completed";
  GoogleSyncErrorStatus["Failed"] = "failed";
})(GoogleSyncErrorStatus || (GoogleSyncErrorStatus = {}));

export const SignupInteractionByEndpointKey = {
  [EndpointKey.GoogleContactsCreateConnection]: 'google-data-sync-creation-connection-error',
  [EndpointKey.GoogleContactsSaveConnection]: 'google-data-sync-save-connection-error',
  [EndpointKey.GoogleContactsActivateSync]: 'google-data-sync-active-sync-error'
};
export const googleContactsSyncAlertCookie = 'googleContactsSyncAlert';
export let GoogleSyncAlertValue;

(function (GoogleSyncAlertValue) {
  GoogleSyncAlertValue["warning"] = "warning";
  GoogleSyncAlertValue["success"] = "success";
})(GoogleSyncAlertValue || (GoogleSyncAlertValue = {}));

export const GoogleSyncErrorStatusByHttpStatus = {
  [HttpStatus.Fetching]: GoogleSyncErrorStatus.Loading,
  [HttpStatus.Error]: GoogleSyncErrorStatus.Failed,
  [HttpStatus.Success]: GoogleSyncErrorStatus.Completed
};